const Ext = require('ext')
const CompanyNewPanel = require('admin/view/CompanyNewPanel')

const CustomerNewPanel = Ext.define(null, {
  extend: CompanyNewPanel,

  module() {
    return require('admin/business/CustomerResource')
  }
})

module.exports = CustomerNewPanel
